/** Define the source of the snippets */
export enum SnippetScope {
	GLOBAL = 'GLOBAL', // Atlassian-owned templates
	USER = 'USER', // My own created template
	SITE = 'SITE', // Site-wide templates that is shared with me
}
